import React from 'react';

import useNewVersionCheck from '../../hooks/useNewVersionCheck';

import envConfig from '../../services/env-config';

import { APP_VERSION } from '../../releases';
import { showNewVersionToast } from '../../releases/newVersionToast';

/** Renders nothing. Prompts a reload when a newer Composer is deployed. */
const NewVersionWatcher: React.FC = () => {
    useNewVersionCheck({
        currentVersion: APP_VERSION,
        basePath: envConfig.BASE_PATH,
        onNewVersion: showNewVersionToast,
        enabled: !import.meta.env.DEV,
    });
    return null;
};

export default NewVersionWatcher;
